import React, { useMemo, useRef } from 'react'

import { Favorite_PageIdEnum } from 'src/api/gen'
import { useURLAndStorageState } from 'src/commons/hooks/useURLAndStorageState'
import { IFilters } from 'src/commons/types'
import { useAgencySettings, useAgencySettingsDistanceUnit, useAgencySettingsSpeedUnit } from 'src/layout/AgencySettings'
import { useProviders } from 'src/layout/hooks'
import { FilteringCard } from 'src/muiv5/components/commons/Cards/FilteringCard'
import { getInitialFilters } from 'src/pages/Dashboard'
import DashboardFilterPanel from 'src/pages/Dashboard/FilterPanel'
import UsersCharts from 'src/pages/Dashboard/UsersCharts'

export default function UsersKPI() {
  const { activeProviders } = useProviders()
  const { get_kpi_filter_range } = useAgencySettings()
  const { value: speedUnit } = useAgencySettingsSpeedUnit()
  const { value: distanceUnit } = useAgencySettingsDistanceUnit()
  const isDurationFilterEnabled = true
  const defaultFilters = useMemo(
    () =>
      getInitialFilters(undefined, get_kpi_filter_range, isDurationFilterEnabled, distanceUnit, speedUnit, false, true),
    [get_kpi_filter_range, isDurationFilterEnabled, distanceUnit, speedUnit]
  )
  const [filters, setFilters] = useURLAndStorageState(
    Favorite_PageIdEnum.trips_user_KPI,
    defaultFilters,
    ['range', 'endRange'],
    {
      range: defaultFilters.range,
      endRange: defaultFilters.endRange,
    }
  )
  const displayedFiltersRef = useRef<IFilters>()

  const onApplyFilter = function () {
    if (!displayedFiltersRef.current) {
      throw new Error('There are no displayed filters')
    }

    setFilters(displayedFiltersRef.current)
  }

  return (
    <FilteringCard
      SideComponent={
        <DashboardFilterPanel
          ref={displayedFiltersRef}
          initialFilters={filters}
          defaultFilters={defaultFilters}
          providers={activeProviders}
          shouldNotDisplayPropulsionType
          shouldNotDisplayLayer
        />
      }
      onApplyFilter={onApplyFilter}
    >
      <UsersCharts filters={filters} />
    </FilteringCard>
  )
}
